const liveList = [
  {
    id: 12,
    type: '科普',
    title: '上海新东方',
    describe: '国际课程demo课',
    avatar: require('../assets/img/avatar/12.png'),
    cover: require('../assets/img/M1_BK/M1_BK_12.png'),
    url: '//cdn-host.media.yunxi.tv/recordM3u8/test_2a30c83104b94bf3b07b0f35d47b3975/d1da16b3ed094370bc1ebde11eaadbc1.m3u8?aliyun_uuid=a92ba4b6d72a4a1097e18b739156d3a3',
    show: false,
  },
  {
    id: 4,
    type: '科普',
    title: '中科体检',
    describe: '食光静好—糖尿病健康饮食',
    avatar: require('../assets/img/avatar/13.png'),
    cover: require('../assets/img/M4_JKKP/M4_JKKP_04.png'),
    url: '//cdn-host.media.yunxi.tv/recordClip/16031/video/7ab842b31558476d816f14dc626c78e0/2b9d7cc059c24077aad4cc4662bfaab1_stT8u.m3u8?aliyun_uuid=2889739572f242828067e2d528c4d88e',
    show: false,
  },
  {
    id: 16,
    type: '演艺',
    title: '安庆职业技术学院2026师生文艺晚会',
    describe: '',
    avatar: require('../assets/img/avatar/8.png'),
    cover: require('../assets/img/M4_JKKP/M4_JKKP_16.png'),
    url: 'https://playback.vlebo.cn/6cc016e0vodcq1500028482/80ac7dbb5145403711118580466/playlist.m3u8',
    show: false,
  },
  {
    id: 34,
    type: '演艺',
    title: '在这里',
    describe: '一起舞动吧',
    avatar: require('../assets/img/avatar/13.png'),
    cover: require('../assets/img/dance/5MM_20210901110054.png'),
    url: 'https://yunxi-material-library.oss-cn-hangzhou.aliyuncs.com/wangwen/5MM.mp4',
    show: false,
  },
  {
    id: 35,
    type: '演艺',
    title: '扇舞的美',
    describe: '民族舞',
    avatar: require('../assets/img/avatar/13.png'),
    cover: require('../assets/img/dance/qianqian_20210901110446.png'),
    url: 'https://yunxi-material-library.oss-cn-hangzhou.aliyuncs.com/wangwen/%E8%8C%9C%E8%8C%9C.mp4',
    show: false,
  },
  {
    id: 36,
    type: '演艺',
    title: '林林',
    describe: '我在这里等你',
    cover: require('../assets/img/dance/linlin_20210901110309.png'),
    avatar: require('../assets/img/avatar/13.png'),
    url: 'https://yunxi-material-library.oss-cn-hangzhou.aliyuncs.com/wangwen/%E6%9E%97%E6%9E%97.mp4',
    show: false,
  },
  {
    id: 37,
    type: '演艺',
    title: '梦圆',
    describe: '圆梦时刻',
    cover: require('../assets/img/dance/tianyuanmeng_20210901112528.png'),
    avatar: require('../assets/img/avatar/13.png'),
    url: 'https://yunxi-material-library.oss-cn-hangzhou.aliyuncs.com/wangwen/%E7%94%B0%E6%A2%A6%E5%9C%86.mp4',
    show: false,
  },
  {
    id: 38,
    type: '演艺',
    title: '一寻',
    describe: '今天在跳舞',
    cover: require('../assets/img/dance/yixun_20210901112746.png'),
    avatar: require('../assets/img/avatar/13.png'),
    url: 'https://yunxi-material-library.oss-cn-hangzhou.aliyuncs.com/wangwen/%E4%B8%80%E5%AF%BB.MOV',
    show: false,
  },
  {
    id: 39,
    type: '演艺',
    title: '我是Joker',
    describe: '带你进入奇幻世界',
    cover: require('../assets/img/magic/moshushijoker_20210901113159.png'),
    avatar: require('../assets/img/avatar/13.png'),
    url: 'https://yunxi-material-library.oss-cn-hangzhou.aliyuncs.com/wangwen/%E9%AD%94%E6%9C%AF%E5%B8%88joker.mp4',
    show: false,
  },
  {
    id: 41,
    type: '演艺',
    title: '方华',
    describe: '笛独奏',
    cover: require('../assets/img/yueqi/di_20210901113504.png'),
    avatar: require('../assets/img/avatar/13.png'),
    url: 'https://yunxi-material-library.oss-cn-hangzhou.aliyuncs.com/wangwen/%E7%AC%9B.mp4',
    show: false,
  },
  {
    id: 42,
    type: '演艺',
    title: '占占',
    describe: '这个乐器有点狂',
    cover: require('../assets/img/yueqi/feizhougu_20210901113638.png'),
    avatar: require('../assets/img/avatar/13.png'),
    url: 'https://yunxi-material-library.oss-cn-hangzhou.aliyuncs.com/wangwen/%E9%9D%9E%E6%B4%B2%E9%BC%93.mp4',
    show: false,
  },
  {
    id: 51,
    type: '演艺',
    title: '泡沫',
    describe: '不一样的烟火',
    cover: require('../assets/img/songer/jiahui_20210901114517.png'),
    avatar: require('../assets/img/avatar/13.png'),
    url: 'https://c-test1.vtest.wlblive.com.cn/page/2054070946792218624',
    show: false,
  },
  {
    id: 52,
    type: '演艺',
    title: '星辰大海',
    describe: '诗和远方的你',
    cover: require('../assets/img/songer/aimer_20210901114649.png'),
    avatar: require('../assets/img/avatar/13.png'),
    url: 'https://yunxi-material-library.oss-cn-hangzhou.aliyuncs.com/wangwen/0824-8Aimer.mov',
    show: false,
  },
  {
    id: 53,
    type: '演艺',
    title: '小布丁',
    describe: '吃货的快乐',
    cover: require('../assets/img/songer/rongrong_20210901114752.png'),
    avatar: require('../assets/img/avatar/13.png'),
    url: 'https://yunxi-material-library.oss-cn-hangzhou.aliyuncs.com/wangwen/0824-9%E8%93%89%E8%93%89.mp4',
    show: false,
  },
  {
    id: 60,
    type: '演艺',
    title: '云旅游之蟳埔村',
    describe: '',
    cover: 'https://playback.vlebo.cn/6cc016e0vodcq1500028482/bf741a241397757894979443915/FoNuJDpV3SUA.jpg',
    avatar: require('../assets/img/avatar/1.png'),
    url: 'https://playback.vlebo.cn/6cc016e0vodcq1500028482/e602fac71397757895382994747/1728957355-1728961079.m3u8',
    show: false,
  },
  {
    id: 61,
    type: '演艺',
    title: '小戏小品大赛',
    describe: '',
    cover: 'https://playback.vlebo.cn/6cc016e0vodcq1500028482/80b1397c1397757892381419757/JAV1I54foqYA.jpg',
    avatar: require('../assets/img/avatar/2.png'),
    url: 'https://playback.vlebo.cn/6cc016e0vodcq1500028482/9edde3f81397757892418610795/playlist.m3u8',
    show: false,
  },
  {
    id: 62,
    type: '演艺',
    title: '美育同行',
    describe: '',
    cover: require('../assets/img/bg62.png'),
    avatar: require('../assets/img/avatar/3.png'),
    url: 'https://playback.vlebo.cn/6cc016e0vodcq1500028482/48b2acda5145403720703270388/playlist.m3u8',
    show: false,
  },
  {
    id: 63,
    type: '演艺',
    title: '美好生活',
    describe: '',
    cover: 'https://playback.vlebo.cn/cbb38da7vodsh1500028482/c8e2ae655145403710870352988/DgJkjaJOvVgA.png',
    avatar: require('../assets/img/avatar/4.png'),
    url: 'https://playback.vlebo.cn/6cc016e0vodcq1500028482/d8c9d8e45145403712238892555/1768011048-1768015194.m3u8',
    show: false,
  },
  {
    id: 64,
    type: '演艺',
    title: '我们一起来唱歌',
    describe: '',
    cover: require('../assets/img/bg64.png'),
    avatar: require('../assets/img/avatar/5.png'),
    url: 'https://playback.vlebo.cn/6cc016e0vodcq1500028482/93d633295145403702300526320/playlist.m3u8',
    show: false,
  },
  {
    id: 65,
    type: '体育',
    title: '运动会',
    describe: '',
    cover: require('../assets/img/bg65.png'),
    avatar: require('../assets/img/avatar/6.png'),
    url: 'https://playback.vlebo.cn/6cc016e0vodcq1500028482/9ba384bc5145403703151644279/playlist.m3u8',
    show: false,
  },
  {
    id: 66,
    type: '科普',
    title: '名医直播',
    describe: '',
    cover: require('../assets/img/bg66.png'),
    avatar: require('../assets/img/avatar/7.png'),
    url: 'https://playback.vlebo.cn/6cc016e0vodcq1500028482/75f57b4d5145403700249208101/playlist.m3u8',
    show: false,
  },
  {
    id: 67,
    type: '演艺',
    title: '2026中国国际美发赏色大秀暨国际养发师节',
    describe: '',
    cover: 'https://playback.vlebo.cn/cbb38da7vodsh1500028482/8c77b2005145403718794804302/tPwAdwmnLowA.png',
    avatar: require('../assets/img/avatar/8.png'),
    url: 'https://playback.vlebo.cn/6cc016e0vodcq1500028482/6b0c600c5145403719892808058/playlist.m3u8',
    show: false,
  },
  {
    id: 68,
    type: '科普',
    title: '科技大讲堂',
    describe: '',
    cover: 'https://playback.vlebo.cn/cbb38da7vodsh1500028482/1fa503105145403721241360704/Iw3WsBQKmesA.png',
    avatar: require('../assets/img/avatar/9.png'),
    url: 'https://playback.vlebo.cn/6cc016e0vodcq1500028482/f21ad5aa5145403721332205501/playlist.m3u8',
    show: false,
  },
  {
    id: 8,
    type: '百科',
    title: '红河锡都影视传媒',
    describe: '潘文婷(微党课)',
    avatar: require('../assets/img/avatar/8.png'),
    cover: require('../assets/img/M1_BK/M1_BK_08.png'),
    url: '//image.yunxi.tv/recordVideoM3u8/20123/f75fd0bccc194759a1a59e36f4b7e608.m3u8',
    show: false,
  },
  {
    id: 15,
    type: '百科',
    title: '新东方合肥学校',
    describe: '安庆路幼儿园教育集团大班家长课堂',
    avatar: require('../assets/img/avatar/15.png'),
    cover: require('../assets/img/M1_BK/M1_BK_15.png'),
    url: '//cdn-host.media.yunxi.tv/recordM3u8/test_cfae025b38dd425c9c001adc0e35b19c/77e8f01180fd439fbd317d729290b3a2.m3u8?aliyun_uuid=c6fb5fa0e08a406bbc985b6be8023566',
    show: false,
  },
  {
    id: 32,
    type: '百科',
    title: '无敌大三脚猫',
    describe: '如何帮助孩子掌握英语学习方法，培养学习兴趣！',
    avatar: require('../assets/img/avatar/17.png'),
    cover: require('../assets/img/M1_BK/M1_BK_32.png'),
    url: '//cdn-host.media.yunxi.tv/recordM3u8/test_c732ba34d5d6404297503a1f65ad7033/d3ecd0fbc8e741d5b1449a469131c35d.m3u8?aliyun_uuid=7c756ae0b18544b5b2d89ebbfe9b4b26',
    show: false,
  },
  {
    id: 2,
    type: '科普',
    title: '廖茂钦',
    describe: '如何提高免疫力',
    avatar: require('../assets/img/avatar/11.png'),
    cover: require('../assets/img/M4_JKKP/M4_JKKP_02.png'),
    url: '//cdn-host.media.yunxi.tv/recordM3u8/test_07b021aec78d42db905493d8bc01ea63/d3fab15e73314b42b6b3aa175292df4e.m3u8?aliyun_uuid=1dcffcb9015e4349ae9a89eda7e28cc1',
    show: false,
  },
  {
    id: 6,
    type: '科普',
    title: '雅莎尔复因',
    describe: '皮肤屏障的影响因素及修复',
    avatar: require('../assets/img/avatar/15.png'),
    cover: require('../assets/img/M4_JKKP/M4_JKKP_06.png'),
    url: '//cdn-host.media.yunxi.tv/recordM3u8/test_d801c9f296034f0fafe4636d461866f8/c323c2fe15b34ccd91926aa81133b887.m3u8?aliyun_uuid=b0965084307f495b84cf2d40bd729e73',
    show: false,
  },
 {
    id: 7,
    type: '科普',
    title: '大理州妇幼保健院',
    describe: '孕期饮食禁忌与营养素',
    avatar: require('../assets/img/avatar/16.png'),
    cover: require('../assets/img/M4_JKKP/M4_JKKP_07.png'),
    url: '//cdn-host.media.yunxi.tv/recordM3u8/test_ccb1595be18445a58da326d4eb22027b/099d07a01cf944b78f1cafafdc74c2a8.m3u8?aliyun_uuid=1e1a99a35b8e4e8eb5e094d9d44661fc',
    show: false,
  },
 {
    id: 8,
    type: '科普',
    title: '德轩堂',
    describe: '知识科普',
    avatar: require('../assets/img/avatar/17.png'),
    cover: require('../assets/img/M4_JKKP/M4_JKKP_08.png'),
    url: '//cdn-host.media.yunxi.tv/recordM3u8/test_fbddd864bbb24e69902964d691b679f1/ae200163e2dc4b7d802d5010af8377bb.m3u8?aliyun_uuid=25a8a68dc439450994d50e81d8401a0f',
    show: false,
  },
  {
    id: 40,
    type: '演艺',
    title: '魔术师李进',
    describe: '魔术世界的奇迹',
    cover: require('../assets/img/magic/moshushilijin_20210901113324.png'),
    avatar: require('../assets/img/avatar/13.png'),
    url: 'https://yunxi-material-library.oss-cn-hangzhou.aliyuncs.com/wangwen/%E9%AD%94%E6%9C%AF%E5%B8%88%E6%9D%8E%E8%BF%9B.mov',
    show: false,
  },
 {
    id: 43,
    type: '演艺',
    title: '钢琴独奏',
    describe: '喜欢肖邦',
    cover: require('../assets/img/yueqi/gangqin_20210901113816.png'),
    avatar: require('../assets/img/avatar/13.png'),
    url: 'https://yunxi-material-library.oss-cn-hangzhou.aliyuncs.com/wangwen/%E9%92%A2%E7%90%B4.mov',
    show: false,
  },
 {
    id: 44,
    type: '演艺',
    title: '古韵秦丝',
    describe: '喜欢古筝的点赞',
    cover: require('../assets/img/yueqi/guzheng_20210901113930.png'),
    avatar: require('../assets/img/avatar/13.png'),
    url: 'https://yunxi-material-library.oss-cn-hangzhou.aliyuncs.com/wangwen/%E5%8F%A4%E7%AD%9D.mov',
    show: false,
  },
{
    id: 45,
    type: '演艺',
    title: '小南',
    describe: '南风知我意',
    cover: require('../assets/img/songer/xiaonan_20210901114813.png'),
    avatar: require('../assets/img/avatar/13.png'),
    url: 'https://yunxi-material-library.oss-cn-hangzhou.aliyuncs.com/wangwen/0823-1%E5%B0%8F%E5%8D%97.mov',
    show: false,
  },
{
    id: 46,
    type: '演艺',
    title: '古城墙',
    describe: '城墙上的你在听歌',
    cover: require('../assets/img/songer/yujinhui_20210901114500.png'),
    avatar: require('../assets/img/avatar/13.png'),
    url: 'https://yunxi-material-library.oss-cn-hangzhou.aliyuncs.com/wangwen/0823-2%E4%BA%8E%E9%87%91%E5%8D%9A.mov',
    show: false,
  },
 {
    id: 47,
    type: '演艺',
    title: '我是嘉音',
    describe: '唱歌给你听',
    cover: require('../assets/img/songer/jiayin_20210901114733.png'),
    avatar: require('../assets/img/avatar/13.png'),
    url: 'https://yunxi-material-library.oss-cn-hangzhou.aliyuncs.com/wangwen/0825-3%E5%98%89%E9%9F%B3%EF%BC%88%E6%96%B0%EF%BC%89.mp4',
    show: false,
  },
 {
    id: 48,
    type: '演艺',
    title: '杨远友',
    describe: '',
    cover: require('../assets/img/songer/yangyuanyou_20210901114610.png'),
    avatar: require('../assets/img/avatar/13.png'),
    url: 'https://yunxi-material-library.oss-cn-hangzhou.aliyuncs.com/wangwen/0823-4%E6%9D%A8%E8%BF%9C%E5%8F%8B.MOV',
    show: false,
  },
  {
    id: 49,
    type: '演艺',
    title: '鑫鑫相印',
    describe: '喜欢的点关注',
    cover: require('../assets/img/songer/xiaoxin_20210901114630.png'),
    avatar: require('../assets/img/avatar/13.png'),
    url: 'https://yunxi-material-library.oss-cn-hangzhou.aliyuncs.com/wangwen/0823-5%20%E5%B0%8F%E9%91%AB.MP4',
    show: false,
  },
  {
    id: 50,
    type: '演艺',
    title: '霄霄小小笑笑',
    describe: '欢迎来听歌',
    cover: require('../assets/img/songer/guanxiaoxiao_20210901114715.png'),
    avatar: require('../assets/img/avatar/13.png'),
    url: 'https://yunxi-material-library.oss-cn-hangzhou.aliyuncs.com/wangwen/0824-6%E5%85%B3%E9%9C%84%E9%9C%84.mov',
    show: false,
  },
  {
    id: 69,
    type: '演艺',
    title: '慢读会',
    describe: '',
    cover: require('../assets/img/bg69.png'),
    avatar: require('../assets/img/avatar/10.png'),
    url: 'https://playback.vlebo.cn/6cc016e0vodcq1500028482/f678ce785145403723787779992/playlist.m3u8',
    show: false,
  },
  {
    id: 70,
    type: '其他',
    title: '消防宣讲',
    describe: '',
    cover: require('../assets/img/bg70.png'),
    avatar: require('../assets/img/avatar/10.png'),
    url: 'https://playback.vlebo.cn/6cc016e0vodcq1500028482/1419c61e5145403723648305913/playlist.m3u8',
    show: false,
  },
  {
    id: 71,
    type: '体育',
    title: '老年气排球精英赛',
    describe: '',
    cover: 'https://playback.vlebo.cn/cbb38da7vodsh1500028482/387aed245145403722496913734/vSHy8rZTfucA.png',
    avatar: require('../assets/img/avatar/10.png'),
    url: 'https://playback.vlebo.cn/6cc016e0vodcq1500028482/2f9602505145403723085898766/playlist.m3u8',
    show: false,
  },
  {
    id: 80,
    type: '其他',
    title: '杏花节',
    describe: '',
    cover: 'https://playback.vlebo.cn/cbb38da7vodsh1500028482/0adfe5de5145403721482505494/eY6uCYm7eToA.png',
    avatar: require('../assets/img/avatar/1.png'),
    url: 'https://playback.vlebo.cn/6cc016e0vodcq1500028482/c91be3075145403721569864741/playlist.m3u8',
    show: false,
  },
  {
    id: 81,
    type: '演艺',
    title: '“国学礼仪记心中”公益展演',
    describe: '',
    cover: require('../assets/img/bg80.png'),
    avatar: require('../assets/img/avatar/2.png'),
    url: 'https://playback.vlebo.cn/6cc016e0vodcq1500028482/1a1df9015145403712619637192/playlist.m3u8',
    show: false,
  },
  {
    id: 82,
    type: '百科',
    title: '名师公开课',
    describe: '',
    cover: require('../assets/img/bg81.png'),
    avatar: require('../assets/img/avatar/3.png'),
    url: 'https://playback.vlebo.cn/6cc016e0vodcq1500028482/5acef1735145403712461118342/playlist.m3u8',
    show: false,
  },
  {
    id: 83,
    type: '百科',
    title: '除法进阶',
    describe: '',
    cover: require('../assets/img/bg82.png'),
    avatar: require('../assets/img/avatar/4.png'),
    url: 'https://c-test1.vtest.wlblive.com.cn/page/2054107128884367360',
    show: false,
  },
  {
    id: 84,
    type: '科普',
    title: '“探秘深海 启迪未来”',
    describe: '',
    cover: 'https://playback.vlebo.cn/cbb38da7vodsh1500028482/fafc4d025145403705848380354/UjtEM7VadicA.png',
    avatar: require('../assets/img/avatar/5.png'),
    url: 'https://playback.vlebo.cn/6cc016e0vodcq1500028482/ef0abd515145403705753210701/playlist.m3u8',
    show: false,
  },
  {
    id: 85,
    type: '其他',
    title: '金融宣介暨投资者教育专场活动',
    describe: '',
    cover: 'https://playback.vlebo.cn/cbb38da7vodsh1500028482/eaa8e7bb5145403704033596470/qFF8sF9kto8A.jpg',
    avatar: require('../assets/img/avatar/6.png'),
    url: 'https://playback.vlebo.cn/6cc016e0vodcq1500028482/15e9aff15145403704740175111/playlist.m3u8',
    show: false,
  },
  {
    id: 86,
    type: '其他',
    title: '2026“苏韵乡情”',
    describe: '',
    cover: 'https://playback.vlebo.cn/cbb38da7vodsh1500028482/7cdba25b5145403720731676432/ITGHd3Dc7RgA.jpg',
    avatar: require('../assets/img/avatar/7.png'),
    url: 'https://playback.vlebo.cn/6cc016e0vodcq1500028482/1788e15e5145403720781539360/playlist.m3u8',
    show: false,
  },
  {
    id: 87,
    type: '科普',
    title: '助产课堂',
    describe: '',
    cover: 'https://playback.vlebo.cn/cbb38da7vodsh1500028482/fa6118fa5145403710755247018/KrPmyuQ33sIA.jpg',
    avatar: require('../assets/img/avatar/8.png'),
    url: 'https://playback.vlebo.cn/6cc016e0vodcq1500028482/1a12e8525145403711589786397/playlist.m3u8',
    show: false,
  },
  {
    id: 88,
    type: '音乐',
    title: '治愈流行金曲 暖心歌唱现场',
    describe: '',
    cover: 'https://playback-test.vlebo.cn/6cc00939vodcq1500028115/661213aa5145403726089465691/nB8pdNbC37oA.png',
    avatar: require('../assets/img/avatar/8.png'),
    url: 'https://c-test1.vtest.wlblive.com.cn/page/2059099850540060672',
    show: false,
  },
  {
    id: 89,
    type: '音乐',
    title: '人间温柔夜话 情感走心聊',
    describe: '',
    cover: 'https://playback-test.vlebo.cn/6cc00939vodcq1500028115/649e22465145403726096199280/aDo1poLOVVsA.png',
    avatar: require('../assets/img/avatar/8.png'),
    url: 'https://c-test1.vtest.wlblive.com.cn/page/2059099300897492992',
    show: false,
  },
  {
    id: 90,
    type: '音乐',
    title: '星光HIFI音乐直播间',
    describe: '',
    cover: 'https://playback-test.vlebo.cn/6cc00939vodcq1500028115/446754c45145403726139782354/GFPMoAm73RUA.png',
    avatar: require('../assets/img/avatar/8.png'),
    url: 'https://c-test1.vtest.wlblive.com.cn/page/2059100031356506112',
    show: false,
  },
  {
    id: 91,
    type: '其他',
    title: '网文直播间测试',
    describe: '',
    cover: 'https://playback-test.vlebo.cn/6cc00939vodcq1500028115/446754c45145403726139782354/GFPMoAm73RUA.png',
    avatar: require('../assets/img/avatar/8.png'),
    url: 'https://c-test1.vtest.wlblive.com.cn/page/2057744068988903424',
    show: false,
  },

]

export default liveList
